import Vue from 'vue'

import { Field, Icon, Popup, Loading, Button, Checkbox, CheckboxGroup, Skeleton, ActionSheet } from 'vant'

Vue.use(Field).use(Icon).use(Popup).use(Loading).use(Button).use(Checkbox).use(CheckboxGroup).use(Skeleton).use(ActionSheet)
